import request from 'utils/request';

export default async function savePartNumber(body: any): Promise<any> {
  try {
    await request(`/lineDriveService/dealDetails/map-deal-partnumbers`, {
      method: 'POST',
      body: body
    });
  } catch (error) {
    let errorMessage = 'Failed to do something exceptional';
    if (error instanceof Error) {
      errorMessage = error.message;
    }
    console.log(errorMessage);
  }
}
